import React from 'react';
import { makeStyles } from '@material-ui/core';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const useStyles = makeStyles({
  tableSortLabel: {
    fontSize: '1em'
  }
});

const HeaderCellSortable = ({
  children,
  sortable,
  direction,
  columnName,
  onChangeSorting
}) => {
  const classes = useStyles();
  if (sortable === false) {
    return children;
  }
  return (
    <TableSortLabel
      active={direction !== null}
      direction={direction || 'asc'}
      classes={{ icon: classes.tableSortLabel }}
      onClick={() =>
        onChangeSorting(columnName, direction === 'asc' ? 'desc' : 'asc')
      }
    >
      {children}
    </TableSortLabel>
  );
};

export default HeaderCellSortable;
